import React, { useContext, useEffect } from 'react'
import { DI, DIProps } from '../../../../Core';
import { StepType, useTour } from '../../../Other/tour';
import { BlockStack, Box, Button, InlineStack, Text } from '@shopify/polaris';
import { UserContext } from '../../../../Actions/NecessaryFun';
import { t } from 'i18next';

const SettingsTour = (props: DIProps & any) => {
    const context = useContext<any>(UserContext);
    const { setIsOpen, setCurrentStep, setSteps, isOpen, currentStep } = useTour();

    const endTour = () => {
        props.di.POST('connector/config/saveConfig', {
            data: [
                {
                    data: JSON.parse(
                        JSON.stringify(
                            {
                                bulk_upload_tour: {
                                    parts_visited: 5,
                                },
                            }
                        )
                    ),
                    group_code: 'tour',
                },
            ],
        }).then((response: any) => {
            setIsOpen(false);
            props.di.globalState.removeLocalStorage('start_tour');
            if (response.success)
                return;
            props.error(
                t('Failed to end tour')
            );
        });
    }

    const getTourData = () => {
        props.di.POST("connector/config/getConfig", {
            group_code: ["tour"],
        }).then((response: any) => {
            if (response.success) {
                let value = response.data.find((a: any) => a.group_code === 'tour')?.value
                if (value?.bulk_upload_tour) {
                    const parts_visited = value?.bulk_upload_tour?.parts_visited ?? 0
                    if (parts_visited === 2) {
                        setIsOpen(true);
                        setCurrentStep(0);
                        setSteps?.(steps)
                    } else {
                        setIsOpen(false);
                        setCurrentStep(0);
                        setSteps?.([]);
                        props?.di.globalState.removeLocalStorage('start_tour');
                    }
                }
            }
        })
    }

    const steps: StepType[] = [
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Create a New Template")}</Text>
                        <Text as="p">
                            {t("A template is like a record where assign your Shopify products to a list, and then enter details about them by following Amazon's specific requirements. This can then be uploaded to Amazon to quickly upload all your assigned products. Click on “next” to proceed.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '',
            OnClose: () => { endTour() },
            position: 'left',
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Generate Template Name")}</Text>
                        <Text as="p">
                            {t("Please enter the name of the template, to help you identify it before you initiate upload. Click on “next” to proceed.")}
                        </Text>
                        <Text as='p' tone='caution'>*{t("Template name is essential before moving on to the next step.")}</Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '.bulktour_template_title',
            stepInteraction: true,
            hideActions: {
                next: true,
                back: true
            },
            position: 'left',
            OnClose: () => { endTour() },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled={props?.templateName === ""}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Choose Fulfilment type")}</Text>
                        <Text as="p">
                            {t("Please enter the preferred fulfillment type in this section. Click on “next” to proceed.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                next: true,
                back: true
            },
            position: 'left',
            selector: '.bulktour_template_fulfillmentType',
            stepInteraction: true,
            OnClose: () => { endTour() },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Select an Appropriate Amazon Category")}</Text>
                        <Text as="p">
                            {t("Now, choose an Amazon category for the products you intend to assign to this template. Click on “next” to proceed.")}
                        </Text>
                        <Text as='p' tone='caution'>*{t("Amazon Category is essential before moving on to the next step.")}</Text>
                    </BlockStack>
                </Box>
            </div>,
            position: 'left',
            padding: { mask: [25, 5, 50, 5] },
            selector: '.bulktour_template_category',
            stepInteraction: true,
            OnClose: () => { endTour() },
            hideActions: {
                next: true,
                back: true
            },
            footer(p) {
                let disabled =
                    props?.categoryData?.category_settings?.primary_category === '' || props?.categoryData?.sub_category === '' || props?.categoryData?.browser_node_id === '' ||
                    (context.isNewTemplate && props?.categoryData?.category_settings?.browser_node_id !== 'default' && (!props?.categoryData?.category_settings?.product_type || !props?.categoryData?.category_settings?.product_type?.[0]))
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary'
                                    onClick={() => { p?.nextClick() }}
                                    disabled={disabled}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div >
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Attribute Mapping")}</Text>
                        <Text as="p">
                            {t("After choosing the appropriate Amazon category, map all required attributes, and optional ones as per your requirement.")}
                        </Text>
                        <Text as='p' tone='critical'>*{t("Mapping the required attributes for all sections is essential before moving on to the next step.")}</Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '.bulktour_template_attributes',
            stepInteraction: true,
            OnClose: () => { endTour() },
            padding: { mask: [25, 5, 25, 5] },
            hideActions: {
                next: true,
                back: true
            },
            footer(p) {
                let disabled = false;
                if (context.isNewTemplate && props?.categoryData?.attributes_mapping?.required_attribute?.length <= 0) {
                    let feedData = props?.JSONFeedRef.current && props?.JSONFeedRef.current.saveJSONFeed(false);
                    if (feedData) {
                        !disabled && (disabled = feedData.hasError)
                    }
                } else {
                    ([...props?.categoryData?.attributes_mapping?.required_attribute ?? [], ...props?.categoryData?.attributes_mapping?.optional_attribute ?? []])
                        .forEach((attribute: any) => {
                            !disabled && (disabled = attribute?.shopify_select === "" ||
                                (attribute?.shopify_select === "Search" && attribute?.shopify_attribute === "") ||
                                (attribute?.shopify_select === "custom" && attribute?.custom_text === "") ||
                                (attribute?.shopify_select === "recommendation" && attribute?.recommendation === "")
                            )
                        })
                }
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' disabled={disabled} onClick={() => { setCurrentStep(a => a + 3) }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Select Optional Attributes")}</Text>
                        <Text as="p">
                            {t("Browse and select any other attribute you wish to add to the product. Click on")} <Text as='strong'>{t("Add attributes")}</Text> {t("button to continue.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '.Polaris-Modal-Dialog__Modal:has(#optional_tour_attribte)',
            stepInteraction: true,
            OnClose: () => { endTour() },
            hideActions: {
                next: true,
                back: true
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Fetch data from amazon")}</Text>
                        <Text as="p">
                            {t("Click on 'Confirm' to fetch data from Amazon.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '.Polaris-Modal-Dialog__Modal:has(#fetch_tour_attribte)',
            stepInteraction: true,
            OnClose: () => { endTour() },
            hideActions: {
                next: true,
                back: true
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Set Inventory")}</Text>
                        <Text as="p">
                            {t("Choose between the given options to manage product inventory levels across Shopify and Amazon for the products you want to assign to this template.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '.bulktour_template_inventory',
            stepInteraction: true,
            OnClose: () => { endTour() },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { setCurrentStep(a => a - 3) }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Set Price")}</Text>
                        <Text as="p">
                            {t("Set and choose to sync the price of your Shopify products listed on Amazon. Manage discounts for the products you want to assign to this template.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '.bulktour_template_price',
            stepInteraction: true,
            OnClose: () => { endTour() },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Settings")}</Text>
                        <Text as="p">
                            {t("Access product details from this section to edit, and manage images, inventory, pricing, and other parameters.")}
                        </Text>
                        <Text as="p">
                            {t("Note: Optimize order fulfillment with handling time. While the default is set to 2 days, feel free to choose your preferred timeline for delivery.")}
                        </Text>
                        <Text as='p' tone='caution'>* {t("Choosing a")} <Text as='strong'>{t("Handling Time")}</Text> {t("is essential before moving on to the next step.")}</Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '.bulktour_template_product',
            stepInteraction: true,
            OnClose: () => { endTour() },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}
                                    disabled={props?.inventorySettings?.inventory_fulfillment_latency === "" || +props?.inventorySettings?.inventory_fulfillment_latency < 1 || +props?.inventorySettings?.inventory_fulfillment_latency > 30}
                                >{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Assign Products in this Template")}</Text>
                        <Text as="p">
                            {t("Filter and select your not-listed Shopify products to create a new product template. You can either select products manually or opt for an advanced selection process.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '.bulktour_template_filter',
            OnClose: () => { endTour() },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Override Existing Products")}</Text>
                        <Text as="p">
                            {t("Enable this option only if you need to reassign products already assigned to other templates.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '.bulktour_template_filter_override',
            stepInteraction: true,
            OnClose: () => { endTour() },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Select filteration type")}</Text>
                        <Text as="p">
                            {t("Filter products using either Manual or Advanced Selection. Select either option and click on “next” to proceed.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '.bulktour_template_filter_choice',
            stepInteraction: true,
            OnClose: () => { endTour() },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled={props?.filterSettings?.filter_type === ""}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Browse Products")}</Text>
                        {props?.filterSettings?.filter_type === 'manual' &&
                            (props?.selectedProductCount < 1 ? <Text as="p">
                                {t("Filter products based on their titles. Type in the title of your desired product and click on <Text as='strong'>Browse</Text>. How this works: if you write 'shirt' then all products that contain 'shirt' in the title will be filtered out for you.")}
                            </Text> : <Text as='p'>{t("Now that you have selected products, click on “next” to proceed.")}
                            </Text>)
                        }
                        {props?.filterSettings?.filter_type === 'advanced' && <>
                            <Text as='p'>
                                {t("Search products by creating Groups, and Rows which help provide accurate query results for you to choose from.")} <Text as='span' tone='caution'>*{t("Do not leave any cell empty. Even if one field is empty, the query results not be displayed.")}</Text>
                            </Text>
                            <Text as='p'>
                                {t("Click on")} <Text as='strong'>{t("See query result")}</Text> {t("to view products. If you see zero products, edit the rows/groups to filter at least one product to continue creating the template.")}
                            </Text>
                        </>
                        }
                    </BlockStack>
                </Box>
            </div>,
            selector: '.bulktour_template_filter_browse',
            stepInteraction: true,
            OnClose: () => { endTour() },
            position: 'top',
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { setCurrentStep(a => a + 2) }} disabled={props?.selectedProductCount < 1}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Select Products")}</Text>
                        <Text as="p">
                            {t("Once the query results are displayed, select all the products you want to assign to the template. Click on")} <Text as='strong'>{t("Continue")}</Text> {t("to assign them.")}
                        </Text>
                        <Text as='p' tone='caution'>*{t("It is mandatory to select at least ONE product to save the template.")}</Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '.Polaris-Modal-Dialog__Modal:has(.bulktour_template_filter_browse_modal)',
            stepInteraction: true,
            OnClose: () => { endTour() },
            position: 'top',
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Save Template")}</Text>
                        <Text as="p">
                            {t("Assign products to the template by clicking on")} <Text as='strong'>{t("SAVE")}</Text> {t("at the top right corner.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '',
            stepInteraction: true,
            OnClose: () => { endTour() },
            position: 'top',
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick(); setCurrentStep(a => a - 2) }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
    ]

    useEffect(() => {
        if (props?.di.globalState.get('start_tour') === 'bulk_upload_1' && !props?.templateId) {
            setTimeout(() => {
                getTourData();
            }, 1000)
        } else {
            setIsOpen(false);
            setCurrentStep(0);
            setSteps?.([])
        }
    }, [])

    useEffect(() => {
        if (props?.di.globalState.get('start_tour') === 'bulk_upload_1' && isOpen && !props?.templateId) {
            setSteps?.(steps)
        }
    }, [props?.templateName, props?.categoryData, props?.inventorySettings, context?.isNewTemplate, props?.jsonDataOnUi, props?.filterSettings, props?.selectedProductCount])

    return null;
}

export default DI(SettingsTour)